import { isEmptySearchValue } from './hooks/use-search-params-form';
/**
 * Toglie i filtri vuoti (`undefined`, `null`, `''`, `[]`): niente parametri a
 * vuoto verso l'API. `false` e `0` restano, sono filtri.
 */
export function compactParams(params) {
    return Object.fromEntries(Object.entries(params).filter(([, value]) => !isEmptySearchValue(value)));
}
//# sourceMappingURL=compact-params.js.map